import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  const legalLinks = [
    { href: '/agb.html', label: t.footer.agb },
    { href: '/datenschutz.html', label: t.footer.privacy },
    { href: '/hilfe.html', label: t.footer.help },
    { href: '/impressum.html', label: t.footer.imprint },
    { href: '/widerruf.html', label: t.footer.widerruf },
  ];

  return (
    <footer className="bg-white border-t border-slate-200">
      <div className="max-w-3xl mx-auto px-5 py-10 text-center">
        <nav
          className="flex flex-wrap items-center justify-center gap-x-2.5 gap-y-2 text-sm text-slate-600 mb-5"
          aria-label={t.footer.navTitle}
        >
          {legalLinks.map((link, index) => (
            <React.Fragment key={link.href}>
              {index > 0 && (
                <span className="text-slate-300 select-none" aria-hidden="true">
                  |
                </span>
              )}
              <a href={link.href} className="hover:text-slate-900 hover:underline transition-colors">
                {link.label}
              </a>
            </React.Fragment>
          ))}
        </nav>

        <p className="text-sm text-slate-700 leading-relaxed mb-3">
          <strong className="font-semibold">{t.footer.company}</strong>
          <br />
          {t.footer.address}
        </p>
        <p className="text-xs text-slate-500">
          © {year} {t.footer.copyright}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
